<template>
  <s-modal
    v-model="showModalHandler"
    size="lg"
    ok-only
    :ok-title="$t('actions.close')"
    :title="$t('general.help')"
    @ok="toggleHelpModal"
  >
    <b-row>
      <b-col cols="12" class="d-flex justify-content-end">
        <b-button-group>
          <b-button
            variant="outline-primary"
            size="sm"
            :class="buttonClass('physical-chemical')"
            @click="selectOption('physical-chemical')"
          >
            {{ $t('general.physical-chemical') }}
          </b-button>
          <b-button
            variant="outline-primary"
            size="sm"
            :class="buttonClass('chromatography')"
            @click="selectOption('chromatography')"
          >
            {{ $t('general.chromatography') }}
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <help-table :moduleSelected="selectedOption" />
      </b-col>
    </b-row>
  </s-modal>
</template>

<script>
import HelpTable from '@/domain/components/generalPanel/analysisProcessing/helpModal/Table';

export default {
  components: {
    HelpTable,
  },
  name: 'HelpModal',
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    showHelpModal: false,
    selectedOption: 'physical-chemical',
  }),
  computed: {
    showModalHandler: {
      get() {
        return this.showModal;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    toggleHelpModal() {
      this.$emit('show-modal');
    },
    selectOption(option) {
      this.selectedOption = option;
    },
    buttonClass(option) {
      return this.selectedOption === option ? 'active' : '';
    },
  },
};
</script>
